import React from "react";
import "./AttractiveFeatures.css";
import FeatureItem from "./FeatureItem";
import { featuresData } from "../../data/FeatureData.js";

const AttractiveFeatures = () => {
  return (
    <section className="features">
      <h1 className="attractive-features">Attractive Features</h1>
      <div className="items">
        {featuresData.map((feature) => (
          <FeatureItem
            key={feature.id}
            icon={feature.icon}
            title={feature.title}
            description={feature.description}
          />
        ))}
      </div>
    </section>
  );
};

export default AttractiveFeatures;
